let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gcJ5Y")).then(() => parcelRequire('jr3Fy'));